const nonPrerenderRequests = [
  'vue-i18n-manager/UPDATE_CONFIGURATION',
  'vue-i18n-manager/SET_LANGUAGE',
  'vue-i18n-manager/SET_TRANSLATION',
  'setting/GET_TRANSLATIONS'
];
export default function requestsLoadPlugin() {
  return (store) => {
    let requestsCount = 0;

    store.subscribeAction({
      before: (action) => {
        if (action.type) {
          if (nonPrerenderRequests.indexOf(action.type) === -1) {
            requestsCount++;
          }
        }
      },
      after: (action, state) => {
        if (action.type) {
          if (nonPrerenderRequests.indexOf(action.type) === -1) {
            requestsCount--;
            if (requestsCount === 0) {
              if (window) {
                store.commit('SET_REQUESTS_COMPLETED_STATUS', true);
              }
            }
          }
        }
      }
    });
  };
}
